<div class="outer-content">
    <div class="float-left bg-white card-background  wh-auto">
        <form [formGroup]="lifestyleForm" autocomplete="off" role="form" class="fieldHeight">
            <div *ngIf="componentRefOfControlType">
                <app-content-top-nav [cdRefParent]="componentRefOfControlType.instance.cdRef" [parentElement]="el" [parentFormToValidate]="componentRefOfControlType.instance.parentForm"
                    [visibleSaveProgress]="!isHOView" [visibleBackNav]='true' (onBackClickHandler)="onBackClick()" [enableBackNav]='!editMode'></app-content-top-nav>
            </div>
            <div  [ngClass]="utilityServiceForMedicalService.currentUWScreenName === 'dependant'? 'col-md-12 clear-all dep-title-wrapper  ':'col-md-12 clear-all title-wrapper'">
                <h1 class="title-text responsive-text-8" id="activityLiving-header">{{contentData.header}}</h1>
            </div>
            <div class="col-md-12 clear-all">
                <div class="col-md-12 to-give-you-the-best">
                    <span id="headerText" [innerHTML]="contentData.headerText"></span>
                </div>
            </div>

            <div class="col-md-12 clear-all content-wrapper clearGaps">
                <div class="col-md-12 clear-all">
                    <ng-template mandatory-questions-dir></ng-template>
                </div>
            </div>

            <div class="col-md-12 underline margin-top"></div>
            <div class="col-md-12 clear-all bottom-container">
                <div *ngIf="componentRefOfControlType">
                    <div class="float-left" *ngIf="!isHOView">
                        <app-save [cdRefParent]="componentRefOfControlType.instance.cdRef" [parentElement]="el" [parentFormToValidate]="componentRefOfControlType.instance.parentForm"
                            [location]="'contentBottom'"></app-save>
                    </div>
                </div>
                <div class="float-right">
                    <app-content-bottom-nav (onNextHandler)="gotoNext()" [userInputDetail]="userInputDetail['buttonConfig']" [buttonType]="'normalCTA'"></app-content-bottom-nav>
                </div>
            </div>
        </form>
    </div>
</div>